import { ReactNode } from "react";

import ActionCard from "ds/components/ActionCard";
import Badge from "ds/components/Badge";
import Banner from "ds/components/Banner";
import Button from "ds/components/Button";
import { IconComponent } from "types/Icon";
import { FederationProvider } from "types/generated";

import { PersonalConnectionsFederation } from "../gql";
import { showDisconnectConfirmation } from "./DisconnectConfirmation";

type ConnectionCardProps = {
  icon: IconComponent;
  name: string;
  description: string;
  provider: FederationProvider;
  federation?: PersonalConnectionsFederation;
  onConnect: () => void;
  errorMessage?: ReactNode;
};

const ConnectionCard = ({
  icon,
  name,
  description,
  provider,
  federation,
  onConnect,
  errorMessage,
}: ConnectionCardProps) => {
  const isConnected = Boolean(federation);
  const showErrorBanner = Boolean(errorMessage) && !isConnected;
  const connectLabel = showErrorBanner ? "Try again" : "Connect";

  const cardDescription = federation ? federation.externalUsername : description;

  return (
    <ActionCard
      icon={icon}
      title={name}
      description={cardDescription}
      titleSuffix={isConnected && <Badge variant="green" type="strong" text="Connected" />}
      actionComponent={
        <>
          {isConnected && (
            <Button
              variant="dangerSecondary"
              onPress={() => showDisconnectConfirmation({ name, provider })}
            >
              Disconnect
            </Button>
          )}
          {!isConnected && (
            <Button variant="secondary" onPress={onConnect}>
              {connectLabel}
            </Button>
          )}
        </>
      }
    >
      {showErrorBanner && (
        <Banner variant="danger" title={`${name} connection failed. Try again.`}>
          {errorMessage}
        </Banner>
      )}
    </ActionCard>
  );
};

export default ConnectionCard;
